<template>
  <div id="main">
      <div class="api_link">
          <span></span>
      </div>
      <div class="details_title select_company_title">{{title}}</div>
      <div class="company-box">
          <ul>
              <li v-for="(list,index) in companyList" :key="index" class="company_list" @click="orderList(list.companyId,list.companyName)">
                <img v-bind:src="list.companyLogo" alt="">
                <p>{{list.companyName}}</p>
              </li>
          </ul>
      </div>
      <bottom></bottom>
      <button class="details_bt_w" @click="back()">{{$t('common.Back')}}</button>
  </div>
</template>

<script>
import logo from '../../assets/image/common/ExpiredLogo.png'
import px from '../../assets/image/selectcompany/4PX.png'
import dhl from '../../assets/image/selectcompany/DHL.png'
import royale from '../../assets/image/selectcompany/Royale.png'
import bottom from '../Bottom.vue'
export default {
  name: 'SelectCompany',
  components: {bottom},
  data () {
    return {
      title: null,
      companyList: [],
      action: null,
      allowAction: {'merchantTakeExpress': true, 'collectExpiredExpress': true, 'select': true}
    }
  },
  beforeCreate: function () {
    document.getElementsByTagName('body')[0].style = 'background-color: #f8f8f8;'
    // 获取操作
    this.action = this.$route.query.action
    let action = this.action
    // 判断是否是允许的操作
    let res = this.actionList
    if (!res[action]) {
      alert('Unknown operation')
      // 未知的操作直接返回
      this.$router.push('/index')
      return false
    }
  },
  created () {
    this.action = this.$route.query.action
    let logisticType = null
    if (this.action === 'merchantTakeExpress') {
      this.title = this.$t('selectCompany.ReturnCourier')
      logisticType = 'COLLECT_RETUREN'
    }
    if (this.action === 'collectExpiredExpress') {
      this.title = this.$t('selectCompany.ReturnExpired')
      logisticType = 'COLLECT_EXPIRED'
    }
    if (this.action === 'select') {
      let tag = this.$route.query.tag
      if (tag === 'courier') {
        this.title = 'Return to courier'
        logisticType = 'COLLECT_RETUREN'
      }
      if (tag === 'expired') {
        this.title = 'Return expired'
        logisticType = 'COLLECT_EXPIRED'
      }
    }
    // 初始化注入&校验时请求页面数据
    const vue = this
    this.axios({
      method: 'GET',
      url: this.api.logistic,
      params: {
        type: logisticType
      }
    }).then(function (response) {
      console.log(vue.action)
      if (vue.action === 'select') {
        let data = response.data
        let name = vue.$route.query.cname
        for (let i = 0; i < response.data.length; i++) {
          if (data[i]['companyName'] === name) {
            vue.companyList.push(data[i])
          } else {
            continue
          }
        }
      } else {
        vue.companyList = response.data
      }
      vue.getLogo()
    }).catch(function (error) {
      console.log(error)
    })
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    getLogo () {
      const vue = this
      // const imgUrl = 'http://ppb.f3322.net:10084/api/file/v1/preview/'
      // const imgUrl = 'https://alfred-uat-api.pakpobox.com/api/file/v1/preview/'
      // const imgUrl = 'https://alfredhk.pakpobox.com/api/file/v1/preview/'
      // const imgUrl = process.env.VUE_APP_IMG_BASE_PATH
      const imgUrl = window.config.VUE_APP_IMG_BASE_PATH
      $.each(this.companyList, function (index, value) {
        if (value.companyLogo) {
          vue.companyList[index].companyLogo = imgUrl + value.companyLogo
        } else {
          vue.companyList[index].companyLogo = logo
        }
      })
    },
    orderList (id, name) {
      if (this.action === 'select') {
        let tag = this.$route.query.tag
        let action = ''
        if (tag === 'courier') {
          action = 'merchantTakeExpress'
        }
        if (tag === 'expired') {
          action = 'collectExpiredExpress'
        }
        this.$router.push('/barcode?action=' + action + '&logisticsId=' + id)
      } else {
        this.$router.push('/return/expired?action=' + this.action + '&id=' + id + '&name=' + name)
      }
    }
  }
}
</script>

<style lang="less" src="../../assets/css/order/selectcompany.css" scoped>

</style>
<style scoped>
    .details_bt_w{
        /* position: fixed; */
        position: sticky;
        width: 83%;
        bottom: 0.38rem;
    }
    .company-box{
        min-height: calc(70vh);
    }

    .bottom{
        /*position: relative;*/
        /*bottom: 0;*/
    }

    .select_company_title{
      color: var(--primary-text-color);
    }
</style>



// WEBPACK FOOTER //
// src/components/Order/SelectCompany.vue